/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerErrorsWidthMillisEnum];


